export default __webpack_public_path__ + "static/media/Kiosko.587af02d.png";